<script lang="ts">
    export let isVisible = false;

    export function generate() {
        const backgroundColorIndex = getRandomInt(backgroundColors.length);
        backgroundColor = backgroundColors[backgroundColorIndex];

        const numberOfObjects = getRandomInt(10) + 5;

        objects = Array.from(Array(numberOfObjects).keys()).map(() => {
            const objectColors = ["#ff0000", "#00ff00", "#0000ff", "#ffff00", "#ff00ff", "#00ffff"];
            const objectColorIndex = getRandomInt(objectColors.length);
            const objectColor = objectColors[objectColorIndex];

            const objectTypes = ["circle", "rect"];
            const objectTypeIndex = getRandomInt(objectTypes.length);
            const objectType = objectTypes[objectTypeIndex];

            const objectSize = getRandomInt(10) + 10;

            const objectX = getRandomInt(width);
            const objectY = getRandomInt(height);

            return {
                color: objectColor,
                type: objectType,
                size: objectSize,
                x: objectX,
                y: objectY,
            }
    });
    }
    const height = 50;
    const width = 100;

    function getRandomInt(max) {
        return Math.floor(Math.random() * max);
    }

    const backgroundColors = ["AliceBlue", "AntiqueWhite", "Beige", "Cornsilk", "Khaki", "LightCyan", "PeachPuff"];
    let backgroundColor = 'white';

    let objects = [];
</script>

{#if isVisible}
    <defs>
        <clipPath id="myClip">
            <rect width={width} height={height} rx="20" />
        </clipPath>
    </defs>

    <rect width={width} height={height} rx="20" fill={backgroundColor} />

    {#each objects as object}
        {#if object.type === "circle"}
            <circle cx={object.x} cy={object.y} r={object.size} fill={object.color} clip-path="url(#myClip)" />
        {:else if object.type === "rect"}
            <rect x={object.x} y={object.y} width={object.size} height={object.size} fill={object.color} clip-path="url(#myClip)" />
        {/if}
    {/each}
{/if}